(() => {
  const start = () => {
    if (!document.querySelector('.TablePress')) return;
    window.setTimeout(() => {
      if (document.getElementById('tablepressProd') || window.TABLEPRESS_APP_LOADING || window.TABLEPRESS_INITIALIZED) return;
      window.TABLEPRESS_APP_LOADING = true;
      window.TP_IDX_url = 'https://app.identixweb.com/';
      if (!document.getElementById('tablepress_react')) {
        const root = document.createElement('div');
        root.id = 'tablepress_react';
        document.body.prepend(root);
      }
      if (!document.getElementById('tablepressCss')) {
        const style = document.createElement('link');
        style.id = 'tablepressCss';
        style.rel = 'stylesheet';
        style.href = 'https://tablepress.identixweb.com/static/css/tablepress.css';
        document.head.append(style);
      }
      const script = document.createElement('script');
      script.id = 'tablepressProd';
      script.src = 'https://tablepress.identixweb.com/tablepress.bundle.js';
      script.addEventListener('load', () => { window.TABLEPRESS_INITIALIZED = true; });
      script.addEventListener('error', () => { window.TABLEPRESS_APP_LOADING = false; });
      document.head.append(script);
    }, 250);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
